import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  GetEarningTypesListingRequest,
  GetEarningTypesListingResponse,
  ICreateEarningTypeRequest,
  IGetEarningTypesByIdRequest,
  IUpdateEarningTypeRequest,
  TSingleEarningTypesResponse,
} from "@/types/(company)/earningTypes.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyEarningTypesApi = createApi({
  reducerPath: "companyEarningTypesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["earningTypes"],
  endpoints: (builder) => ({
    createEarningTypes: builder.mutation<
      TSingleEarningTypesResponse,
      ICreateEarningTypeRequest
    >({
      query: (body) => {
        return {
          url: "/company/settings/earning-types",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["earningTypes"],
    }),
    getEarningTypes: builder.query<
      GetEarningTypesListingResponse,
      GetEarningTypesListingRequest
    >({
      query: (params) => ({
        url: "/company/settings/earning-types",
        method: "GET",
        params: params ?? undefined,
      }),
      providesTags: ["earningTypes"],
    }),
    getEarningTypesById: builder.query<
      TSingleEarningTypesResponse,
      IGetEarningTypesByIdRequest
    >({
      query: (param) => {
        return {
          url: "/company/settings/earning-types" + `/${param.id}`,
          method: "GET",
        };
      },
      providesTags: ["earningTypes"],
    }),
    updateEarningTypes: builder.mutation<
      TSingleEarningTypesResponse,
      IUpdateEarningTypeRequest
    >({
      query: ({ id, ...body }) => {
        return {
          url: "/company/settings/earning-types" + `/${id}`,
          method: "PATCH",
          body: body.data,
        };
      },
      invalidatesTags: ["earningTypes"],
    }),
    deleteEarningTypes: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: "/company/settings/earning-types" + `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["earningTypes"],
    }),
  }),
});

export const {
  useGetEarningTypesQuery,
  useCreateEarningTypesMutation,
  useGetEarningTypesByIdQuery,
  useUpdateEarningTypesMutation,
  useDeleteEarningTypesMutation,
} = companyEarningTypesApi;
